/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { VcdrPatchProperties } from './vcdrPatchProperties';
import { MigrationProperties } from './migrationProperties';
import { OfferRegionEnum } from './offerRegionEnum';
import { VmcfsPatchProperties } from './vmcfsPatchProperties';


export interface OrgPatchSpec { 
    /**
     * VCDS Org type.
     */
    org_type?: string;
    migration_properties?: MigrationProperties;
    offer_region?: OfferRegionEnum;
    /**
     * Update the offer region of the org.
     */
    update_offer_region?: boolean;
    vcdr_properties?: VcdrPatchProperties;
    vmcfs_properties?: VmcfsPatchProperties;
}
export namespace OrgPatchSpec {
}


